












































import Vue from "vue";

export default Vue.extend({
  name: "DefinedUnitSelector",
  components: {},
  props: ["currentUnit"],
  data() {
    return {
      visible: false,
      commonList: [],
      myList: [],
    };
  },
  computed: {
    enableSaveList(): any {
      var list = this.commonList.concat(this.myList);
      return this.currentUnit && list.filter((item) => item.label == this.currentUnit).length === 0;
    },
  },
  mounted() {
    this.commonList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.CommonUnitList"]) : [];
    this.myList = abp.setting && abp.setting.values ? JSON.parse(abp.setting.values["App.MyUnitList"]) : [];

    this.$Notice.config({
      top: 120,
      duration: 3,
    });
  },
  methods: {
    handleClick(item) {
      this.visible = false;
      this.$emit("on-select", item);
    },
    handleRemove(item) {
      for (var i = 0; i < this.myList.length; i++) {
        if (this.myList[i] === item) {
          this.myList.splice(i, 1);
        }
      }

      this.changeUnitList();
    },
    handleSaveToPredefined() {
      let id = 0;
      this.myList.forEach((item) => {
        if (item.value > id) {
          id = item.value;
        }
      });
      id = id + 1;
      this.myList.push({ value: id, label: this.currentUnit, disabled: false });

      this.changeUnitList();
    },
    changeUnitList() {
      this.$store.dispatch("review/changeMyUnitList", { model: JSON.stringify(this.myList) }).then((response) => {
        if (response.data && response.data.success === true) {
          abp.setting.values["App.MyUnitList"] = JSON.stringify(this.myList);
        }

        this.$Notice.success({
          title: "Save",
          desc: "My unit list updated!",
        });
      });
    },
  },
});
